type Params = {
  userId: string
  conditions: {
    isActivateUser: boolean
    hasTieup: boolean
    hasAgreed: boolean
  }
}

export class UserReceivingGiftConditions {
  constructor(private params: Params) {}

  canReceive(): boolean {
    return [
      this.params.conditions.isActivateUser,
      this.params.conditions.hasTieup,
      this.params.conditions.hasAgreed,
    ].every((v) => v)
  }

  hasTieup(): boolean {
    return this.params.conditions.hasTieup
  }

  hasAgreed(): boolean {
    return this.params.conditions.hasAgreed
  }
}
